module.exports = __webpack_public_path__ + "static/media/kite.437e47d1.svg";